module.exports = __webpack_public_path__ + "img/camper-white.3f8c1149.svg";